<template>
    <div>
        <div style="display: flex;">
            <div style="border-right: 1px dashed #d9d9d9;" :style="{'width': myComponent.leftWidth + 'px'}"
            v-if="myComponent.showLeft">
                <drag-form-page-wraper
                    ref="dragFormWraper"
                    :select.sync="selectWidget"
                    :componentsList="leftComponents"
                    :plist="parentComponents"
                />
            </div>
            <div :style="contentWidth">
                <drag-form-page-wraper
                    ref="dragFormWraper"
                    :select.sync="selectWidget"
                    :componentsList="centerComponents"
                    :plist="parentComponents"
                />
            </div>
            <div style="border-left: 1px dashed #d9d9d9;" :style="{'width': myComponent.rightWidth + 'px'}"
            v-if="myComponent.showRight">
                <drag-form-page-wraper
                    ref="dragFormWraper"
                    :select.sync="selectWidget"
                    :componentsList="rightComponents"
                    :plist="parentComponents"
                />
            </div>
        </div>
      <el-button
        title="复制"
        @click.stop="handleWidgetClone(index)"
        class="drag-table-action-clone"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="primary"
      >
        <i class="el-icon-copy-document"></i>
      </el-button>
      <el-button
        title="删除"
        @click.stop="handleWidgetDelete(index)"
        class="drag-table-action-delete"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="danger"
      >
        <i class="el-icon-delete"></i>
      </el-button>
    </div>
  </template>
  <script>
  import mixin from "./mixin";
  export default {
    name: "drag-form-horizontal-layout",
    mixins: [mixin()],
    data() {
      return {
        form: {},
      };
    },
    computed: {
      leftComponents() {
        return this.myComponent.leftComponents;
      },
      centerComponents() {
        return this.myComponent.centerComponents;
      },
      rightComponents() {
        return this.myComponent.rightComponents;
      },
      contentWidth(){
        var leftWidth = this.myComponent.showLeft ? this.myComponent.leftWidth : 0;
        var rightWidth = this.myComponent.showRight ? this.myComponent.rightWidth : 0;
        return `width: calc(100% - ${leftWidth}px - ${rightWidth}px)`
      }
    },
    methods: {
      handleWidgetClone(index) {
        let cloneData = this.$deepClone(this.myComponent);
        cloneData.prop = Date.now() + "_" + Math.ceil(Math.random() * 99999);
        cloneData.table = "";
        cloneData.field = "";
        this.setAllProp(cloneData.children);
        this.parentComponents.splice(index, 0, cloneData);
        this.$nextTick(() => {
          this.handleSelectWidget(index + 1);
          this.$emit("change");
        });
      },
      handleFormClickAdd(item) {
        console.log(item);
        console.log(this.myComponent);
        // this.childrenComponents.push(item);
        // this.$refs.dragFormWraper.handleFormAdd(
        //   { newIndex: this.childrenComponents.length - 1 },
        //   true
        // );
      },
    },
  };
  </script>
  